module.exports = __webpack_public_path__ + "assets/eb3954b37813e89ca40ed8d3b399a78f.png";